import ClientNotesCard from "./client-card-notes";

export default ClientNotesCard;